import React from 'react'
import * as styles from '../../styles/components/content-blocks/link.module.scss'
import CrosshairLink from '../crosshair-link'
import { FeaturedLink } from '../../utils/types'

export type LinkBlockProps = FeaturedLink

const LinkBlock = ({ href, label, internalLink, openInNewTab }: LinkBlockProps) => {
    return (
        <div className={styles.container}>
            <CrosshairLink
                as={internalLink ? 'internalLink' : 'externalLink'}
                href={href}
                label={label}
                openInNewTab={openInNewTab}
            />
        </div>
    )
}

export default LinkBlock
